import { SignInButton, SignUpButton } from '@clerk/clerk-react'
import { UserPlus, LogIn, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AuthPromptProps {
  /** Message to display */
  message?: string
  /** Optional custom icon */
  icon?: LucideIcon
  /** Additional className for the container */
  className?: string
}

/**
 * Inline auth prompt with Sign Up and Log In buttons.
 * Use this for empty states that require authentication.
 */
export function AuthPrompt({ 
  message = 'Sign up or log in to continue',
  icon: Icon,
  className,
}: AuthPromptProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-16 text-center", className)}>
      {Icon && (
        <div className="p-4 rounded-2xl bg-white/[0.03] border border-white/[0.06] mb-5">
          <Icon className="size-10 text-[#555]" />
        </div>
      )}
      
      <p className="text-[#888] mb-6 text-sm">
        {message}
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <SignUpButton mode="modal">
          <button className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-white hover:bg-white/90 text-black text-sm font-medium transition-colors">
            <UserPlus className="size-4" />
            Join Free
          </button>
        </SignUpButton>
        
        <SignInButton mode="modal">
          <button className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-white/[0.05] border border-white/[0.1] hover:bg-white/[0.08] text-white text-sm font-medium transition-colors">
            <LogIn className="size-4" />
            Log In
          </button>
        </SignInButton>
      </div>
    </div>
  )
}
